"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomStatistic = void 0;

var _react = _interopRequireDefault(require("react"));

var Value = function Value(props) {
  var value;

  switch (props.size) {
    case 'lg':
      value = /*#__PURE__*/_react.default.createElement("h1", {
        className: "mb-0 font-weight-bold"
      }, props.value);
      break;

    case 'md':
      value = /*#__PURE__*/_react.default.createElement("h2", {
        className: "mb-0 font-weight-bold"
      }, props.value);
      break;

    case 'sm':
      value = /*#__PURE__*/_react.default.createElement("h3", {
        className: "mb-0 font-weight-bold"
      }, props.value);
      break;

    default:
      value = /*#__PURE__*/_react.default.createElement("h3", {
        className: "mb-0 font-weight-bold"
      }, props.value);
  }

  return value;
};

var CustomStatistic = function CustomStatistic(props) {
  var size = props.size,
      value = props.value,
      title = props.title;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Value, {
    value: value,
    size: size
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-0 text-muted"
  }, title));
};

exports.CustomStatistic = CustomStatistic;
CustomStatistic.defaultProps = {
  size: 'md'
};
var _default = CustomStatistic;
exports.default = _default;